'use client';

import { ComponentType, CSSProperties } from 'react';

import { cn } from '../../../lib';

interface IChartTooltipIndicatorProps {
  hideIndicator?: boolean;
  indicator?: 'line' | 'dot' | 'dashed';
  indicatorColor?: string;
  itemConfig?: {
    icon?: ComponentType;
  };
  nestLabel?: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * Renders the indicator for the chart tooltip.
 */
export function ChartTooltipIndicator({
  hideIndicator = false,
  indicator = 'dot',
  indicatorColor,
  itemConfig,
  nestLabel = false,
}: IChartTooltipIndicatorProps) {
  if (itemConfig?.icon) {
    return <itemConfig.icon />;
  }

  if (hideIndicator) {
    return null;
  }

  return (
    <div
      className={cn(
        `border-(--color-border) bg-(--color-bg)
        shrink-0 rounded-[2px]`,
        {
          'h-2.5 w-2.5': indicator === 'dot',
          'w-1': indicator === 'line',
          'w-0 border-[1.5px] border-dashed bg-transparent':
            indicator === 'dashed',
          'my-0.5': nestLabel && indicator === 'dashed',
        }
      )}
      style={
        {
          '--color-bg': indicatorColor,
          '--color-border': indicatorColor,
        } as CSSProperties
      }
    />
  );
}
